import { RECEIVE_LOCATION, RECEIVE_PROVIDERS_BY_LOCATION } from './actions';

import { CLEAR_DATA } from '../actions';

export const DEFAULT_STATE = {
  locationsById: {},
  providersByLocationId: {}
};

const mapLocationData = (locationId, data) => {
  // Handle null/undefined locationId gracefully by converting to string first
  const safeLocationId = String(locationId).toUpperCase();
  return {
    [safeLocationId]: data
  };
};

export default function locationReducer(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case RECEIVE_LOCATION:
      // Handle null/undefined payload gracefully
      if (!action.payload) {
        return state;
      }
      return {
        ...state,
        locationsById: {
          ...state.locationsById,
          ...mapLocationData(action.payload.locationId, action.payload.data)
        }
      };
    case RECEIVE_PROVIDERS_BY_LOCATION:
      return {
        ...state,
        providersByLocationId: {
          ...state.providersByLocationId,
          ...mapLocationData(action.payload.locationId, action.payload.data)
        }
      };
    case CLEAR_DATA:
      return {};
    default:
      return state;
  }
}
